<script>
  import { backInOut } from "svelte/easing";
  import { fly } from "svelte/transition";
  import { clickOutside } from "../../helpers/utils.svelte";
  export let visible = false;
  export let onClose = null;
  export let title = "";

  const onClickOutside = () => {
    if (typeof onClose === "function") {
      onClose();
    }
    visible = false;
  };
</script>
<style>
  .custom-width {
    width: 40%;
    height: unset !important;
  }
@media screen and (max-width: 1024px) {
  .custom-width {
    width: 75%;
    height: unset !important;
  }
}
</style>
{#if visible}
  <div
    transition:fly={{ easing: backInOut, x: 100 }}
    use:clickOutside
    on:clickOutside={onClickOutside}
    class="position-absolute card profile-card shadow-lg top-0 custom-width"
    style="z-index: 2;right: 0px;"
  >
    {#if title}
      <h1 class="p-4 border-bottom">{title}</h1>
    {/if}
    <slot />
  </div>
{/if}
